import React from 'react';
import { DialogTitle, DialogContent, Typography } from '@mui/material';
import { SimpleModal } from 'components/Modal';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';
import { ModalButtonContainer } from '../FeedbackPage.styles';

interface NegativeSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  hygienistFirstName: string;
}

const NegativeSuccessModal: React.FC<NegativeSuccessModalProps> = ({
  isOpen,
  onClose,
  hygienistFirstName,
}) => {
  return (
    <SimpleModal isOpen={isOpen} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>Thank You!</DialogTitle>
      <DialogContent>
        <Typography align="left" gutterBottom>
          We really appreciate your feedback. We track negative feedback internally to manage our membership and ensure we're only connecting offices with the best members.
          <br /><br />
          Over the course of 1,000's of placements, 97% of offices report "Happy" or "Very Happy", so we're sorry the ball got dropped here.
          <br />
          They have been blocked from viewing any of your future postings.
          <br /><br />
          <b>A friendly reminder:</b> Standard placement fees apply to future shifts booked with {hygienistFirstName}, whether arranged on the app or through direct contact.
        </Typography>
      </DialogContent>
      <ModalButtonContainer>
        <StyledButton
          variant="contained"
          onClick={onClose}
        >
          OK
        </StyledButton>
      </ModalButtonContainer>
    </SimpleModal>
  );
};

export default NegativeSuccessModal;
